import {BaseApi} from "@/http/api/BaseApi";
import errorHandler from "@/providers/ErrorHandler";

export default class ReportCommentServices extends BaseApi {

    acceptReport = async (data : any) => {
        try {
            const response : any = await this.post("reports" , data)
            if (response.status || response.statusCode === 200) {
                return response;
            }
            await Promise.reject(response)
        }catch (error) {
            errorHandler(error)
        }
    }
}